import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { WidgetComponent, WidgetComponentConfig, WidgetOrchestratorService } from '@examdojo/core/widget';
import { provideJsxgraphWidgets } from '@examdojo/math-widget';
import { v4 as uuid } from 'uuid';
import { WidgetBlock } from '../../../model';

@Component({
  selector: 'dojo-widget-block-renderer',
  template: `
    <div class="widget-wrapper">
      <dojo-widget [config]="widgetConfig()" />
    </div>
  `,
  styles: `
    :host {
      @apply block my-6;
    }

    .widget-wrapper {
      height: 400px;
      @apply rounded-xl overflow-hidden;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [WidgetComponent],
  providers: [provideJsxgraphWidgets(), WidgetOrchestratorService],
  host: {
    draggable: 'false',
  },
})
export class WidgetBlockRendererComponent {
  readonly block = input.required<WidgetBlock>();

  readonly widgetConfig = computed<WidgetComponentConfig>(() => {
    const config = this.block().config as unknown as WidgetComponentConfig | undefined;
    return {
      ...config,
      // Ensure a unique ID for each widget instance
      id: config?.['id'] ?? `widget-${uuid()}`,
    } as WidgetComponentConfig;
  });
}
